import React from 'react';
import LocationTemplate from './LocationTemplate';

const GatesvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Gatesville"
      stateName="North Carolina"
      countyName="Gates"
      zipCodes={["27938"]}
      latitude={36.4062}
      longitude={-76.7578}
      population={302}
      historicalFact="County seat of Gates County, established in 1779 and named after Revolutionary War General Horatio Gates."
      nearbyTowns={[
        "Ahoskie, NC",
        "Murfreesboro, NC",
        "Winton, NC",
        "Elizabeth City, NC",
        "Suffolk, VA",
        "Hertford, NC",
        "Sunbury, NC",
        "Rich Square, NC"
      ]}
    />
  );
};

export default GatesvillePage;